import template from './import_time_logged.html';
import tr from '../../lib/default-translator.js';

class AdminImportTimeViewModel
{
    constructor(dialog)
    {
        this.dialog = dialog;
        this.departments = ko.observableArray();
        this.department_id = ko.observable();

        // Observables for file input values
        this.modifyBatchFilePath = ko.observable('');

        this.modifyBatchFilePath.subscribe((newValue) => {
            let upload_time_input = document.getElementById('upload_time_input');
            if (upload_time_input)
                upload_time_input.value = newValue.replace('C:\\fakepath\\', '');
        });
    }

    close()
    {
        this.dialog.close(true);
    }

    disableImportButtons()
    {
        document.getElementById('import_time_browse').disabled = true;
        document.getElementById('import_time_button').disabled = true;
        $("#import_notice").show();
    }

    enableImportButtons()
    {
        $("#import_notice").hide();
        document.getElementById('import_time_browse').disabled = false;
        document.getElementById('import_time_button').disabled = false;
    }

    disableModifyButtons()
    {
        document.getElementById('import_time_browse').disabled = true;
        document.getElementById('import_time_button').disabled = true;
        document.getElementById('close_button_top').disabled = true;
        document.getElementById('close_button').disabled = true;
        $('#import_modify_notice').show();
    }

    enableModifyButtons()
    {
        $('#import_modify_notice').hide();
        document.getElementById('import_time_browse').disabled = false;
        document.getElementById('import_time_button').disabled = false;
        document.getElementById('close_button_top').disabled = false;
        document.getElementById('close_button').disabled = false;
    }

    show_employee_details_help()
    {
        Grape.dialog.open('TimeImportHelp', { employee_id: this.dialog.bindings.id });
    }
}

class AdminImportTimePage
{
    constructor(bindings)
    {
        this.bindings = bindings;
        this.viewModel = new AdminImportTimeViewModel(this);
    }

    async init()
    {
        let cache_results = [];

        cache_results = await Promise.all([
            Grape.cache.get('DepartmentCompanyList')
        ]);

	    let rows = Array.isArray(cache_results?.[0]) ? cache_results[0] : cache_results;

	    let departments = rows.map(r => ({
				...r,
				// ensure name exists in case upstream didn't set it
				name: r.name ?? `${r.department} (${r.company})`
				}));

        this.viewModel.departments(departments);

        let modifyBatchFileInput = document.getElementById('time_batch_file');
        if (modifyBatchFileInput)
        {
            modifyBatchFileInput.addEventListener('change', (event) => {
                if (event.target.files.length > 0)
                {
                    let filePath = event.target.value;
                    this.viewModel.modifyBatchFilePath(filePath);
                }
            });
        }
    }

    async importmodifyEXCELClick(v, e, force_override = false)
    {
        let button_disabled = document.getElementById('import_time_button');
        if (button_disabled.disabled)
            return;

        if ($('#upload_time_input').val() == '')
        {
            Grape.alerts.alert({
                type: 'error',
                message: tr('Please select a file'),
                title: tr('Error', 'Error')
            });
            return;
        }

        let formData = new FormData($('#modifytimebatchuploadform')[0]);
        let file = document.getElementById('time_batch_file').files[0];

        if (file) 
        {
            if (file.size > 20000000)
            {
                Grape.alerts.alert({ type: 'error', message: tr('File size exceeds the maximum limit of 20MB'), title: tr('Error') });
                formData.append('abort_upload', 'true');
                return;
            }
        }

        formData.append('filename', $('#upload_time_input').val());

        if (force_override)
        {
            formData.append('force', 'true');
            console.log('force override is true')
        }

        try {
            this.viewModel.disableModifyButtons();
            let response = await fetch('/admin/validate_time_logged_excel', {
                method: 'POST',
                body: formData
            });
        
            if (!response.ok && response.status >= 500) 
                throw new Error(`Server error: ${response.status}`);
        
            let res;
            try
            {
                res = await response.json();
            }
             catch (jsonError)
            {
                throw new Error('Invalid response from server');
            }
        
            if (res.status === 'SUCCESS')
            {
                let success_message = res.message;

                if (res.newEntries > 0 && res.updatedEntries > 0)
                {
                    success_message += `<br><br><strong>Details:</strong><br>`;
                    success_message += `• ${res.newEntries} new time entries were created<br>`;
                    success_message += `• ${res.updatedEntries} existing time entries were updated`;
                }
                else if (res.updatedEntries > 0)
                {
                    success_message += `<br><br><strong>Details:</strong><br>`;
                    success_message += `• All ${res.updatedEntries} time entries were updates to existing records`;
                }
                else if
                (res.newEntries > 0) {
                    success_message += `<br><br><strong>Details:</strong><br>`;
                    success_message += `• All ${res.newEntries} time entries were created as new records`;
                }

                if (res.duplicates_overridden > 0) 
                    success_message += `<br><br>${res.duplicates_overridden} duplicate entries were overridden.`;

                if (res.duplicates_skipped > 0) 
                    success_message += `<br><br>${res.duplicates_skipped} duplicate entries were skipped.`;
            
                await Grape.alerts.alert({ 
                    type: 'success', 
                    message: success_message, 
                    title: tr('Import Successful') 
                });
                this.close();
            }
            else if (res.status === 'ERROR') 
            {
                // Show validation errors in alert before continuing
                await Grape.alerts.alert({ 
                    type: 'error', 
                    message: `${res.message}<br><br>Please fix the errors in your file and try again.`, 
                    title: 'Import Validation Failed' 
                });
                this.viewModel.enableModifyButtons();
            }
            else if (res.status === 'DUPLICATES_FOUND')
            {
                if (res.processedEntries > 0 || res.newEntries > 0)
                {
                    let success_message = '';
                    if (res.newEntries > 0) 
                        success_message = `Successfully processed ${res.newEntries} time entries.`;
                    else if (res.processedEntries > 0) 
                        success_message = `Successfully processed ${res.processedEntries} time entries.`;

                    await Grape.alerts.alert({
                        type: 'success',
                        message: success_message,
                        title: 'Partial Import Successful'
                    });
                }

                let duplicate_details = '';
                let overlap_summary = '';

                if (res.duplicates && res.duplicates.length > 0)
                {
                    // Group duplicates by employee for better display
                    const grouped_duplicates = _.groupBy(res.duplicates, 'employee_name');

                    duplicate_details = '<br><br><strong>Time Entries with Overlapping Times:</strong><br>';

                    Object.keys(grouped_duplicates).forEach(employee_name => {
                        let employee_duplicates = grouped_duplicates[employee_name];
                        duplicate_details += `<strong>${employee_name}:</strong><br>`;

                        employee_duplicates.forEach(dup => {
                            duplicate_details += `• Row ${dup.row}: ${dup.entry['Start Time *']} - ${dup.entry['End Time *']} on ${dup.entry['Date *']}<br>`;
                        });
                        duplicate_details += '<br>';
                    });

                    let unique_employees = Object.keys(grouped_duplicates).length;
                    overlap_summary = `Found ${res.duplicates.length} overlapping time entries for ${unique_employees} employee${unique_employees > 1 ? 's' : ''}`;
                }
            
            
                let confirmation_message = `${res.message}`;

                if (res.newEntries > 0) 
                    confirmation_message += `<br><br>✅ ${res.newEntries} time entries were successfully created.`;

                confirmation_message += `${duplicate_details}<br>`;
                confirmation_message += `<strong>Would you like to update the overlapping time entries with the data from your spreadsheet?</strong>`;
                confirmation_message += `<br><br><small><em>Clicking "Update" will replace the existing time log data with the information from your spreadsheet.</em></small>`;
            
                // Re-enable buttons
                this.viewModel.enableModifyButtons();

                let confirmed = await Grape.alerts.confirm({ 
                    type: 'warning', 
                    message: confirmation_message, 
                    title: `${overlap_summary}`
                });
            
                if (confirmed) 
                    await this.importmodifyEXCELClick(v, e, true);
                else
                {
                    let final_message = `Import completed.`;
                    if (res.processedEntries > 0) 
                         final_message += ` ${res.processedEntries} entries were successfully processed.`;

                    if (res.newEntries > 0) 
                        final_message += ` ${res.newEntries} new time entries were created.`;

                    final_message += ` ${res.duplicates.length} overlapping entries were skipped.`;
                    await Grape.alerts.alert({
                        type: 'info',
                        message: final_message,
                        title: 'Import Summary'
                    });
                }

            }
        
        }
        catch (error) {
            console.error('Caught error:', error);
            Grape.alerts.alert({ 
                type: 'error', 
                message: tr('An error occurred while processing your request.'), 
                title: tr('Error') 
            });
            this.viewModel.enableModifyButtons();
        }
    }

    import_time_format(v, e)
    {
        window.location.href = '/admin/download_time_logged_format/' + this.viewModel.department_id() + '/null';
    }

}

export default {
    name: 'AdminImportTime',
    dialog_class: AdminImportTimePage,
    template: template,
    template_filename: 'translation/dialogs/import_time_logged',
    provider: 'ps'
}
